import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { LoginModal } from '../components/auth/LoginModal';
import { RegisterModal } from '../components/auth/RegisterModal';
import { EmailVerificationModal } from '../components/auth/EmailVerificationModal';

export function LandingPage() {
  const [showLogin, setShowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [showVerification, setShowVerification] = useState(false);
  const [pendingEmail, setPendingEmail] = useState('');
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  const handleRegisterSuccess = (email: string) => {
    setPendingEmail(email);
    setShowRegister(false);
    setShowVerification(true);
  };

  const handleVerificationSuccess = () => {
    setShowVerification(false);
    setShowLogin(true);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-green-100">
      <div className="container mx-auto px-4 py-16">
        <div className="text-center">
          <h1 className="text-5xl font-bold text-green-800 mb-4 flex items-center justify-center">
            <span>Auxilio</span>
            <img src="/favicon.svg" alt="" className="h-12 w-12 mx-2 inline-block" />
            <span>Time</span>
          </h1>
          <p className="text-xl text-green-600 mb-8">
            Personal Time Tracking Made Simple
          </p>

          <div className="flex justify-center gap-4 mb-16">
            <button
              onClick={() => setShowLogin(true)}
              className="px-8 py-3 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition-colors"
            >
              Sign In
            </button>
            <button
              onClick={() => setShowRegister(true)}
              className="px-8 py-3 bg-white text-green-600 border-2 border-green-600 rounded-lg font-semibold hover:bg-green-50 transition-colors"
            >
              Get Started
            </button>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="bg-white p-6 rounded-xl shadow-md">
              <div className="text-4xl mb-4">📊</div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Track Time</h3>
              <p className="text-gray-600">Log hours against clients and projects with ease</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-md">
              <div className="text-4xl mb-4">📅</div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Calendar View</h3>
              <p className="text-gray-600">Select any day to view and add time entries</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-md">
              <div className="text-4xl mb-4">📄</div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Export Reports</h3>
              <p className="text-gray-600">Generate CSV or PDF reports for any date range</p>
            </div>
          </div>
        </div>
      </div>

      <LoginModal
        isOpen={showLogin}
        onClose={() => setShowLogin(false)}
        onSwitchToRegister={() => {
          setShowLogin(false);
          setShowRegister(true);
        }}
      />

      <RegisterModal
        isOpen={showRegister}
        onClose={() => setShowRegister(false)}
        onSuccess={handleRegisterSuccess}
        onSwitchToLogin={() => {
          setShowRegister(false);
          setShowLogin(true);
        }}
      />

      <EmailVerificationModal
        isOpen={showVerification}
        email={pendingEmail}
        onClose={() => setShowVerification(false)}
        onSuccess={handleVerificationSuccess}
      />
    </div>
  );
}
